function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { useNavigationListItem } from "@sprout/list-navigation";
import { Text } from "sprout-ui-primitives";
import { Activity } from "./Activity";
const ActivityPageListItem = (props)=>{
    const { header , result , activity , moreActivities , subject  } = props;
    const { navProps , helpers: navigationItemHelpers  } = useNavigationListItem(String(activity.id), useMemo(()=>({
            object: activity
        }), [
        activity
    ]));
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            header && /*#__PURE__*/ _jsx(Text, {
                fontWeight: "bold",
                fontSize: 3,
                mt: 7,
                mb: 0,
                mx: 3,
                lineHeight: "48px",
                children: header
            }),
            /*#__PURE__*/ _jsx("div", _objectSpread({}, navProps, {
                style: navigationItemHelpers.isActive ? {
                    backgroundColor: "rgba(25, 118, 210, 0.04)"
                } : undefined,
                children: result === "passthrough" ? /*#__PURE__*/ _jsx(Activity, {
                    activity: activity,
                    moreActivities: moreActivities,
                    subject: subject
                }) : result
            }))
        ]
    });
};
export default ActivityPageListItem;
